<template>
  <v-dialog class="dialog-monitoring" v-model="getShow">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        Monitoramento - {{ getItem.date }}

        <v-chip
          v-if="!showActions"
          class="mx-5"
          :color="getColor(getItem.state)"
          >{{ getItem.state }}</v-chip
        >
        <v-spacer />
        <v-btn icon @click.prevent="actionShowDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <mapbox
        :zoom="8"
        :position="[-50.440266, -27.683528]"
        height="400px"
        width="100%"
        :points="createPoint()"
      />
      <v-card-text>
        <v-row>
          <v-col
            ><span class="title">
              Cultivares:
            </span>
            <v-chip>{{ getItem.cultivars }}</v-chip></v-col
          >
          <v-col
            ><span class="title">Idade:</span>
            <v-chip>{{ getItem.age }} Anos</v-chip></v-col
          >
        </v-row>
        <v-row>
          <v-col
            ><span class="title">Observações:</span>
            <p class="comments-text">
              {{ getItem.comments }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <viewer :images="getImages">
              <img
                class="image"
                height="250"
                width="200"
                v-for="(image, index) in getImages"
                :key="index"
                :src="image"
              />
            </viewer>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions v-if="showActions">
        <v-spacer></v-spacer>
        <v-btn color="error" @click.prevent="editState('Positivo')">
          Positivo
        </v-btn>
        <v-btn color="warning" @click.prevent="editState('Análise presencial')">
          Análise presencial
        </v-btn>
        <v-btn color="success" @click.prevent="editState('Negativo')">
          Negativo
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "dialog-monitoring",
  data: () => ({
    loading: false
  }),
  props: {
    showActions: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      getShow: "dialog/getShow",
      getItem: "dialog/getItem",
      getImages: "dialog/getImages",
      getUser: "auth/getUser"
    })
  },
  components: {
    mapbox: () => import("../map")
  },
  methods: {
    ...mapActions({
      actionShowDialog: "dialog/actionShowDialog",
      actionEditAnalyze: "monitoring/actionEditAnalyze"
    }),

    getColor(item) {
      if (item != undefined) {
        item = item.toLowerCase();
        if (item == "positivo") return "error";
        else if (item == "análise presencial") return "warning";
        else return "success";
      }
    },
    editState(state) {
      this.loading = !this.loading;
      this.actionEditAnalyze({
        id: this.getItem.id,
        state: state,
        user_id: this.getUser.id
      })
        .then(() => {
          console.log(state);
          this.loading = !this.loading;
          this.actionShowDialog();
        })
        .catch(error => {
          console.log(error);
          this.loading = !this.loading;
        });
    },
    createPoint() {
      return [
        {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [this.getItem.lon, this.getItem.lat]
          }
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.col {
  font-size: 18px;
}
.title {
  font-weight: 600;
  padding: 0 1rem 0 0;
}
.comments-text {
  word-wrap: break-word;
  line-height: 1.5rem;
  padding: 0 0 0 2rem;
}
.image {
  border-radius: 15px;
  transition: 0.4s;
  margin: 1rem;
  &:hover {
    cursor: pointer;
    filter: brightness(0.5);
  }
}
</style>
